import React, { Component } from 'react';

import 'babel-polyfill';

import { Form, Icon, Input, Button, Card, Modal } from "antd";
import { reactLocalStorage } from "reactjs-localstorage";
import "../styles/css/login.scss";
import { login, getRegisterCode, loginCode, register, forgetPassword, getForgetCode } from "./api/categories";

class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            hospital: '',
            password: '',
            phone: '',
            smsCode: '',
            timeLeft: 60,
            isCountingDown: false,
        };
    }

    validatePhoneNumber = (phone) => {
        // Regular expression: starts with 1, followed by 10 digits
        const phoneRegex = /^1[3-9]\d{9}$/;
        return phoneRegex.test(phone);
    }

    getLoginCode = async () => {
        const { phone } = this.state;
        if (this.validatePhoneNumber(phone)) {
            console.log("Phone number format is correct");
            if (!this.state.isCountingDown) {
                this.startTimer();
                try {
                    // Using GET request, passing parameters
                    const res = await getForgetCode({
                        phone: phone,
                    });

                    console.log(res);
                    if (res.code !== "200") {
                        alert(res.msg);
                    }
                } catch (error) {
                    console.error("Request failed:", error);
                    alert("Request failed, please try again later");
                }
            }
        } else {
            alert("Incorrect phone number");
        }
    };

    handleSmsLogin = async (e) => {
        e.preventDefault();
        // Here you can perform form validation and submission logic
        console.log('Registration information:', this.state);
        const { password, phone, smsCode } = this.state;

        try {
            // Using GET request, passing parameters
            const res = await forgetPassword({
                password: password,
                phone: phone,
                code: smsCode,
            });

            console.log(res);
            if (res.code === "200") {
                alert("Password updated successfully");
                this.props.history.push("/");
            } else {
                alert(res.msg);
            }
        } catch (error) {
            console.error("Request failed:", error);
            alert(res.msg);
        }
    };

    inputChangeUserName = (e) => {
        this.setState({ userName: e.target.value });
    };

    inputChangeHospital = (e) => {
        this.setState({ hospital: e.target.value });
    };

    inputChangePassword = (e) => {
        this.setState({ password: e.target.value });
    };

    inputChangePhoneNumber = (e) => {
        this.setState({ phone: e.target.value });
    };

    inputChangeSmsCode = (e) => {
        this.setState({ smsCode: e.target.value });
    };

    startTimer = () => {
        this.setState({ isCountingDown: true });
        this.countdown = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.timeLeft > 0) {
                    return { timeLeft: prevState.timeLeft - 1 };
                } else {
                    clearInterval(this.countdown);
                    return { isCountingDown: false, timeLeft: 60 };
                }
            });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.countdown) {
            clearInterval(this.countdown);
        }
    }

    render() {
        const { phone, smsCode } = this.state;
        const { timeLeft, isCountingDown } = this.state;
        const buttonText = isCountingDown ? `${timeLeft} seconds` : 'Dispatch';

        return (
            <div className="login-main">
                <div className="login-bg">
                    <div style={{ fontSize: "33px", width: "500px", marginLeft: "5%", textAlign: "center" }}>
                        <Form
                            onSubmit={this.handleSmsLogin}
                            className="login-form"
                            style={{ padding: "20px", marginLeft: "10px" }}
                        >
                            <h1 className="login-title">Reset Password</h1>

                            <Form.Item
                                name="phoneNumber"
                                rules={[{ required: true, message: "Please enter Mobile" }]}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                                    <div style={{ width: "150px" }}>Mobile:</div>
                                    <Input
                                        onChange={this.inputChangePhoneNumber}
                                        prefix={<Icon type="phone" className="login-input-icon" />}
                                        placeholder="Mobile"
                                    />
                                </div>
                            </Form.Item>

                            <Form.Item
                                name="password"
                                rules={[{ required: true, message: "Please enter new password" }]}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                                    <div style={{ width: "150px" }}>NewPassword:</div>
                                    <Input
                                        type="password"
                                        onChange={this.inputChangePassword}
                                        prefix={<Icon type="lock" className="login-input-icon" />}
                                        placeholder="New Password"
                                    />
                                </div>
                            </Form.Item>

                            <Form.Item
                                name="confirmPassword"
                                rules={[{ required: true, message: "Please re-enter new password" }]}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                                    <div style={{ width: "150px" }}>ConfirmPassword:</div>
                                    <Input
                                        type="ConfirmPassword"
                                        prefix={<Icon type="lock" className="login-input-icon" />}
                                        placeholder="Re-enter New Password"
                                    />
                                </div>
                            </Form.Item>

                            <Form.Item
                                name="smsCode"
                                rules={[{ required: true, message: "Please enter Verify" }]}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                                    <div style={{ width: "150px" }}>Verify:</div>
                                    <div style={{ width: "100%", marginLeft: "-40px" }}>
                                        <Input
                                            style={{ width: "73%" }}
                                            onChange={this.inputChangeSmsCode}
                                            prefix={<Icon type="key" className="login-input-icon" />}
                                            placeholder="Verify"
                                        />
                                    </div>
                                    <Button
                                        style={{ width: "20%" }}
                                        type="primary"
                                        className="login-join-button"
                                        onClick={this.getLoginCode}
                                        disabled={isCountingDown}
                                    >
                                        {buttonText}
                                    </Button>
                                </div>
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="login-join-button"
                                >
                                    Reset Password
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgetPassword;